import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import './style.css';
import XtractIcon from '../Assets/XtractorWhite.svg';
import SplashScreen from './splashScreen';
import SplashVideo from '../Assets/Desktop.webm';

function LoginPage() {

    const navigate = useNavigate()

    const [Signin, setSignIn] = useState(false);
    const [Username, setUsername] = useState('');
    const [Password, setPassword] = useState('');
    const [ShowError, setShowError] = useState(false);
    const [HideSplash, setHideSplash] = useState(true);

    const handleClick = () => {
        if(Username === 'Spiralcubes' && Password === '1234'){
            setShowError(false)
            navigate('/Home')
        }
        else{
            setShowError(true)
            navigate('/')
        }
    }

    const handleChange = (value) => {
        setUsername(value)
        if(value === 'SpiralCubes'){
            setShowError(false)
        }
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => {
          setHideSplash(false)
        }, 2500);
    
        return () => clearTimeout(timeoutId);
      }, [HideSplash]);

  return (
    <>
    {HideSplash ?
    <SplashScreen /> :
    <div>
        {/* <Header login={true} border={true}/> */}
        <div className='row p-0 m-0' style={{height: '100vh', overflowY: 'hidden'}}>
            <div className='col-5 p-0 m-0' style={{height: '100%'}}>
                <img className='head-text' src={XtractIcon} width='120px' />
                <p className='sub-head-text'>You can Xtract your document here</p>
                <video className="VideoTag" autoPlay loop muted>
                    <source src={SplashVideo} type="video/mp4" />
                </video>
            </div>
            <div className='col-7 dis-props p-0 m-0' style={{height: '100%'}}>
             {Signin ?
              <div className='text-start' style={{width: '60%'}}>
                <div>
                    <p className='mb-0' style={{fontSize: '22px', fontWeight: '600'}}>Sign Up</p>
                    <p className='mb-3' style={{fontSize: '13px', fontWeight: '300'}}>Enter your details in the below fields to create account</p>
                </div>
                <div className="mb-2">
                    <label htmlFor="FormControlInput1" className="form-label" style={{fontSize: '13px'}}>User Name</label>
                    <input type="text" className="form-control" id="FormControlInput1" placeholder="Enter Username" style={{fontSize: '13px'}} />
                </div>
                <div className="mb-2">
                    <label htmlFor="FormControlInput2" className="form-label" style={{fontSize: '13px'}}>Email address</label>
                    <input type="email" className="form-control" id="FormControlInput2" placeholder="Name@example.com" style={{fontSize: '13px'}} />
                </div>
                <div className="mb-2">
                    <label htmlFor="FormControlInput3" className="form-label" style={{fontSize: '13px'}}>Password</label>
                    <input type="password" className="form-control" id="FormControlInput3" placeholder="Enter Password" style={{fontSize: '13px'}} />
                </div>
                <div className="mb-4">
                    <label htmlFor="FormControlInput4" className="form-label" style={{fontSize: '13px'}}>Re-Enter Password</label>
                    <input type="password" className="form-control" id="FormControlInput4" placeholder="Re-Enter Password" style={{fontSize: '13px'}} />
                </div>
                <div className='text-center'>
                    <button type="button" className="blueButton mb-3">Sign Up</button>
                    <p className='mb-0' style={{fontSize: '12px', fontWeight: '300'}}>If you have an account already, click here to <span style={{color: '#0734ea', cursor: 'pointer', fontWeight: '500'}} onClick={() => setSignIn(false)}>Sign In</span></p>
                </div>
              </div>
                :
              <div className='text-start' style={{width: '60%'}}>
                <div>
                    <p className='mb-0' style={{fontSize: '22px', fontWeight: '600'}}>Sign In</p>
                    <p className='mb-3' style={{fontSize: '13px', fontWeight: '300'}}>Sign In your account here</p>
                </div>
                <div className="mb-2">
                    <label htmlFor="FormControlInput2" className="form-label" style={{fontSize: '13px', fontWeight: '500'}}>User Name</label>
                    <input type="email" className="form-control" id="FormControlInput2" placeholder="Enter your username" style={{fontSize: '13px'}} onChange={(e) => handleChange(e.target.value)}/>
                </div>
                <div className={ShowError ? "mb-2" : "mb-4"}>
                    <label htmlFor="FormControlInput3" className="form-label" style={{fontSize: '13px', fontWeight: '500'}}>Password</label>
                    <input type="password" className="form-control" id="FormControlInput3" placeholder="Enter your password" style={{fontSize: '13px'}} onChange={(e) => setPassword(e.target.value)}/>
                </div>
                {ShowError && <p className='mb-3' style={{fontSize: '12px', color: 'red'}}>Incorrect Username & Password</p>}
                <div className='text-center'>
                    {/* <button type="button" className="btn btn-primary mb-2" style={{width: '30%', background: '0734ea', fontWeight: '500'}} onClick={handleClick}>Sign In</button> */}
                    <button type="button" className="blueButton mb-3" onClick={handleClick}>Sign In</button>
                    <p className='mb-0' style={{fontSize: '12px', fontWeight: '300'}}>If you don't have an account, click here to create account <span style={{color: '#0734ea', cursor: 'pointer', fontWeight: '500'}} onClick={() => setSignIn(true)}>Sign Up</span></p>
                </div>
              </div>}
            </div>
        </div>
    </div>}
    </>
  )
}

export default LoginPage;
